module.exports = __webpack_public_path__ + "img/hzLogo9.6c2ac5b2.png";